import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../store/Store";
import {
  setMessages,
  getMessages,
  updateMessages,
  addEventImage,
  getEventImagesById,
  exportFormat,
  getPackagePricing,
  createPackagePricing,
  updatePackagePricing,
  exportInvoice,
  generateAcreditations,
  getEventInfo,
  updateIsSoldOut,
  updateIsComingSoon,
} from "./modules/actions";
import { getParticipants } from "../Participants/modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    loggedUser: state.user.loggedUser,
    messages: state.dashboardReducer.messages,
    isUploading: state.dashboardReducer.loading,
    participants: state.participantsReducer.participants,
    eventInfo: state.dashboardReducer.event,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      setMessages,
      getMessages,
      updateMessages,
      exportFormat,
      exportInvoice,
      generateAcreditations,
      getParticipants,
      getEventInfo,
      updateIsSoldOut,
      updateIsComingSoon,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
